import { RequestService } from '../../../../../common/services/RequestService';
import { GET_PROFILES } from '../constants';

export const getProfiles = payload => {
  return RequestService.get(GET_PROFILES);
};
